import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import MyPageNavigate from '../../components/MyPageNavigate/MyPageNavigate';
import styles from './MyCard.module.scss';
import plus from '../../assets/plus02.png';
import { isDesktop } from 'react-device-detect';
import leftArrow from '../../assets/leftArrow02.png';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import LoginHandler from '../../components/LoginHandler/LoginHandler';

interface ICardType {
  card_member: '이주연';
  card_name: 'NH채움';
  card_num: '4854-****-****-1195';
  card_type: '개인';
}
function MyCard() {
  const navigate = useNavigate();
  let [card, setCard] = useState<ICardType>();
  useEffect(() => {
    axiosClient.get('/data/mypage/payple_card').then((res) => {
      if (res.data.data.status == 'success') setCard(res.data.data.data);
    });
  }, []);
  function handleDeleteCard() {
    let confirm = window.confirm(
      'Would you like to delete the registered card?',
    );
    if (!confirm) return;
    axiosClient
      .delete('/data/mypage/payple_card')
      .then((res) => {
        alert('The card has been deleted.');
        setCard(undefined);
      })
      .catch((err) => alert('An error occurred. Please try again.'));
  }
  return (
    <div>
      <Header />
      <LoginHandler />
      <div className={styles.contentWrap}>
        {isDesktop && <MyPageNavigate />}
        <h3 className={`${styles.title} ${!isDesktop ? styles.isMobile : ''}`}>
          {!isDesktop && (
            <img src={leftArrow} alt="leftArrow" onClick={() => navigate(-1)} />
          )}
          <span>간편 카드 등록</span>
        </h3>
        <div className={styles.myCardsWrap}>
          <h4>
            등록된카드 <span>{card ? 1 : 0}</span> 장
          </h4>
          {card && (
            <ul className={styles.cardList}>
              <li className={styles.card}>
                <span className={styles.cardDelete} onClick={handleDeleteCard}>
                  삭제
                </span>
                <div className={styles.cardInfo}>
                  <h5>{card.card_name}</h5>
                  <span>{card.card_num}</span>
                </div>
              </li>
            </ul>
          )}
          {/* <div className={styles.appendCardBtn}>
            <img src={plus} alt="plus" />
            <span>카드 등록</span>
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default MyCard;
